<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import SubBtnBox from 'components/subBtnBox';
import {
  withdraw,
} from 'api/getPay';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/getPay/account/platform/withdraw',
      formComponents: ['baseForm'],
      editParams: {
      },
    };
  },
  computed: {
    detailParams () {
      return {
        customerId: this.$route.query.id,
      };
    },
  },
  methods: {
    editApi: withdraw,
    handleSubSucc () {
      this.$alert('提现申请成功，等待银行处理，预计2小时到账!', '提交成功', {
        confirmButtonText: '确定',
      });
      this.close();
    },
  },
  async mounted () {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
